import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fee-config',
  templateUrl: './fee-config.component.html',
  styleUrls: ['./fee-config.component.scss']
})
export class FeeConfigComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
